import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppFooter, LazyAppHeader, LazyAppJob, LazyAppPwaHeader, LazyNkFormularBeteiligungsplattform, LazyNkFormularFaqKiesabbauFragen, LazyNkTemplateFormularSchlaglochmelder, LazyNkAccordion, LazyNkAddress, LazyNkAlert, LazyNkBadge, LazyNkBox, LazyNkBreadcrumb, LazyNkButton, LazyNkCaptcha, LazyNkCard, LazyNkCarousel, LazyNkCarouselSlide, LazyNkCol, LazyNkContainer, LazyNkDate, LazyNkDivider, LazyNkDrawer, LazyNkDrilldown, LazyNkFilterbar, LazyNkForm, LazyNkIcon, LazyNkImage, LazyNkInput, LazyNkInputCheckbox, LazyNkInputFile, LazyNkInputGroup, LazyNkInputMultiSelect, LazyNkInputRadio, LazyNkInputSelect, LazyNkInputText, LazyNkInputTextarea, LazyNkInputWysiwyg, LazyNkLink, LazyNkList, LazyNkListItem, LazyNkLoader, LazyNkMeta, LazyNkModal, LazyNkNav, LazyNkNavItem, LazyNkPagination, LazyNkRow, LazyNkSidebar, LazyNkTab, LazyNkTabs, LazyNkText, LazyNkTitle, LazyNkWrapper, LazyNkFilterAktuellesJahre, LazyNkFilterBrancheneintraegeRubriken, LazyNkFilterRatsinfosystemSitzungen, LazyNkFilterVeranstaltungenDatum, LazyNkFilterVeranstaltungenRubriken, LazyNkNinaNotification, LazyNkPage, LazyNkPageDefault, LazyNkPagePortal, LazyNkPageReversed, LazyNkPageWide, LazyNkServiceBwLeistungen, LazyNkSidebarAktuelles, LazyNkSidebarAmt, LazyNkSidebarAnsprechpartner, LazyNkSidebarArtikel, LazyNkSidebarBrancheneintrag, LazyNkSidebarBrancheneintragAktuelles, LazyNkSidebarBrancheneintragVeranstaltungen, LazyNkSidebarDokumente, LazyNkSidebarFilterBrancheneintraege, LazyNkSidebarFilterVeranstaltungen, LazyNkSidebarIntranet, LazyNkSidebarLinks, LazyNkSidebarRatsinfosystem, LazyNkSidebarServiceBwFachbereich, LazyNkSidebarServiceBwKontaktperson, LazyNkSidebarSprechzeiten, LazyNkSidebarSubmenu, LazyNkSidebarText, LazyNkSidebarVeranstaltungen, LazyNkTemplateAbfalltermine, LazyNkTemplateAbfalltermineReminderConfirm, LazyNkTemplateAccessibility, LazyNkTemplateAemterDetail, LazyNkTemplateAemterMitarbeiterUebersicht, LazyNkTemplateAemterUebersicht, LazyNkTemplateAktuelles, LazyNkTemplateAmt, LazyNkTemplateArchivUebersicht, LazyNkTemplateArtikelDetail, LazyNkTemplateArtikelUebersicht, LazyNkTemplateAusschreibungen, LazyNkTemplateAusstattung, LazyNkTemplateBaugebieteDetail, LazyNkTemplateBaugebieteFlurstuecke, LazyNkTemplateBaugebieteKarte, LazyNkTemplateBaugebieteUebersicht, LazyNkTemplateBildergalerie, LazyNkTemplateBildergalerieWebcontact, LazyNkTemplateBrancheneintraege, LazyNkTemplateBrancheneintraegeDetail, LazyNkTemplateBrancheneintraegeRubrik, LazyNkTemplateBrancheneintraegeRubriken, LazyNkTemplateBrancheneintrag, LazyNkTemplateDokumente, LazyNkTemplateFilterBrancheneintraege, LazyNkTemplateFilterRatsinfosystem, LazyNkTemplateFilterVeranstaltungen, LazyNkTemplateFormularAbfalltermineReminder, LazyNkTemplateFormularBrancheneintrag, LazyNkTemplateFormularCorona, LazyNkTemplateFormularFuehrungenAnfrage, LazyNkTemplateFormularKontakt, LazyNkTemplateFormularPauschalenAnfrage, LazyNkTemplateFormularPinnwand, LazyNkTemplateFormularSchadensmeldung, LazyNkTemplateFormularVeranstaltung, LazyNkTemplateFormularVerein, LazyNkTemplateGoogleAlbums, LazyNkTemplateHeader, LazyNkTemplateIFrame, LazyNkTemplateIntranetArtikelUebersicht, LazyNkTemplateIntranetConfig, LazyNkTemplateIntranetLogin, LazyNkTemplateIntranetLogout, LazyNkTemplateIntranetPasswortChange, LazyNkTemplateIntranetPasswortNew, LazyNkTemplateIntranetPasswortReset, LazyNkTemplateKontakt, LazyNkTemplateLinks, LazyNkTemplateMitarbeiter, LazyNkTemplateMitarbeiterDetail, LazyNkTemplateMitarbeiterUebersicht, LazyNkTemplateOeffnungszeiten, LazyNkTemplateOrt, LazyNkTemplatePagination, LazyNkTemplatePinnwandDetail, LazyNkTemplatePinnwandPortal, LazyNkTemplatePinnwandSperren, LazyNkTemplatePinnwandUebersicht, LazyNkTemplatePortal, LazyNkTemplatePreise, LazyNkTemplatePwaUebersicht, LazyNkTemplateRaeteTaetigkeitsbereicheUebersicht, LazyNkTemplateRaeteUebersicht, LazyNkTemplateRatsinfosystemBericht, LazyNkTemplateRatsinfosystemBerichteUebersicht, LazyNkTemplateRatsinfosystemDetail, LazyNkTemplateRatsinfosystemLogin, LazyNkTemplateRatsinfosystemLogout, LazyNkTemplateRatsinfosystemPasswortAendern, LazyNkTemplateRatsinfosystemTermin, LazyNkTemplateRatsinfosystemTermineUebersicht, LazyNkTemplateRatsinfosystemUebersicht, LazyNkTemplateServiceBwAbc, LazyNkTemplateServiceBwFormulare, LazyNkTemplateServiceBwKontaktpersonen, LazyNkTemplateServiceBwKontaktpersonenDetails, LazyNkTemplateServiceBwLebenslagen, LazyNkTemplateServiceBwLebenslagenDetails, LazyNkTemplateServiceBwLeistungen, LazyNkTemplateServiceBwLeistungsDetails, LazyNkTemplateServiceBwOrganisationseinheit, LazyNkTemplateServiceBwOrganisationseinheiten, LazyNkTemplateServiceBwOrganisationseinheitenMinimal, LazyNkTemplateServiceBwOrganisationseinheitsDetails, LazyNkTemplateSpacing, LazyNkTemplateSuche, LazyNkTemplateVeranstaltungen, LazyNkTemplateVeranstaltungenDetail, LazyNkTemplateVeranstaltungenUebersicht, LazyNkTemplateVideothekWebcontact, LazyNkTemplateWegweiserAbc, LazyNkTemplateWegweiserFormulare, LazyNkTemplateWegweiserLebenslageVerfahren, LazyNkTemplateWegweiserLebenslagen, LazyNkTemplateWegweiserUebersicht, LazyNkTemplateWegweiserVerfahren, LazyNkTemplateWegweiserVerfahrenDetail, LazyNkTemplateWegweiserVerfahrenVorgaenge, LazyNkTemplateWidgetNetzeBW, LazyNkTemplateZeitstrahl, LazyNkAnnouncement, LazyNkWidgetPushNotification } from '#components'
const lazyGlobalComponents = [
  ["AppFooter", LazyAppFooter],
["AppHeader", LazyAppHeader],
["AppJob", LazyAppJob],
["AppPwaHeader", LazyAppPwaHeader],
["NkFormularBeteiligungsplattform", LazyNkFormularBeteiligungsplattform],
["NkFormularFaqKiesabbauFragen", LazyNkFormularFaqKiesabbauFragen],
["NkTemplateFormularSchlaglochmelder", LazyNkTemplateFormularSchlaglochmelder],
["NkAccordion", LazyNkAccordion],
["NkAddress", LazyNkAddress],
["NkAlert", LazyNkAlert],
["NkBadge", LazyNkBadge],
["NkBox", LazyNkBox],
["NkBreadcrumb", LazyNkBreadcrumb],
["NkButton", LazyNkButton],
["NkCaptcha", LazyNkCaptcha],
["NkCard", LazyNkCard],
["NkCarousel", LazyNkCarousel],
["NkCarouselSlide", LazyNkCarouselSlide],
["NkCol", LazyNkCol],
["NkContainer", LazyNkContainer],
["NkDate", LazyNkDate],
["NkDivider", LazyNkDivider],
["NkDrawer", LazyNkDrawer],
["NkDrilldown", LazyNkDrilldown],
["NkFilterbar", LazyNkFilterbar],
["NkForm", LazyNkForm],
["NkIcon", LazyNkIcon],
["NkImage", LazyNkImage],
["NkInput", LazyNkInput],
["NkInputCheckbox", LazyNkInputCheckbox],
["NkInputFile", LazyNkInputFile],
["NkInputGroup", LazyNkInputGroup],
["NkInputMultiSelect", LazyNkInputMultiSelect],
["NkInputRadio", LazyNkInputRadio],
["NkInputSelect", LazyNkInputSelect],
["NkInputText", LazyNkInputText],
["NkInputTextarea", LazyNkInputTextarea],
["NkInputWysiwyg", LazyNkInputWysiwyg],
["NkLink", LazyNkLink],
["NkList", LazyNkList],
["NkListItem", LazyNkListItem],
["NkLoader", LazyNkLoader],
["NkMeta", LazyNkMeta],
["NkModal", LazyNkModal],
["NkNav", LazyNkNav],
["NkNavItem", LazyNkNavItem],
["NkPagination", LazyNkPagination],
["NkRow", LazyNkRow],
["NkSidebar", LazyNkSidebar],
["NkTab", LazyNkTab],
["NkTabs", LazyNkTabs],
["NkText", LazyNkText],
["NkTitle", LazyNkTitle],
["NkWrapper", LazyNkWrapper],
["NkFilterAktuellesJahre", LazyNkFilterAktuellesJahre],
["NkFilterBrancheneintraegeRubriken", LazyNkFilterBrancheneintraegeRubriken],
["NkFilterRatsinfosystemSitzungen", LazyNkFilterRatsinfosystemSitzungen],
["NkFilterVeranstaltungenDatum", LazyNkFilterVeranstaltungenDatum],
["NkFilterVeranstaltungenRubriken", LazyNkFilterVeranstaltungenRubriken],
["NkNinaNotification", LazyNkNinaNotification],
["NkPage", LazyNkPage],
["NkPageDefault", LazyNkPageDefault],
["NkPagePortal", LazyNkPagePortal],
["NkPageReversed", LazyNkPageReversed],
["NkPageWide", LazyNkPageWide],
["NkServiceBwLeistungen", LazyNkServiceBwLeistungen],
["NkSidebarAktuelles", LazyNkSidebarAktuelles],
["NkSidebarAmt", LazyNkSidebarAmt],
["NkSidebarAnsprechpartner", LazyNkSidebarAnsprechpartner],
["NkSidebarArtikel", LazyNkSidebarArtikel],
["NkSidebarBrancheneintrag", LazyNkSidebarBrancheneintrag],
["NkSidebarBrancheneintragAktuelles", LazyNkSidebarBrancheneintragAktuelles],
["NkSidebarBrancheneintragVeranstaltungen", LazyNkSidebarBrancheneintragVeranstaltungen],
["NkSidebarDokumente", LazyNkSidebarDokumente],
["NkSidebarFilterBrancheneintraege", LazyNkSidebarFilterBrancheneintraege],
["NkSidebarFilterVeranstaltungen", LazyNkSidebarFilterVeranstaltungen],
["NkSidebarIntranet", LazyNkSidebarIntranet],
["NkSidebarLinks", LazyNkSidebarLinks],
["NkSidebarRatsinfosystem", LazyNkSidebarRatsinfosystem],
["NkSidebarServiceBwFachbereich", LazyNkSidebarServiceBwFachbereich],
["NkSidebarServiceBwKontaktperson", LazyNkSidebarServiceBwKontaktperson],
["NkSidebarSprechzeiten", LazyNkSidebarSprechzeiten],
["NkSidebarSubmenu", LazyNkSidebarSubmenu],
["NkSidebarText", LazyNkSidebarText],
["NkSidebarVeranstaltungen", LazyNkSidebarVeranstaltungen],
["NkTemplateAbfalltermine", LazyNkTemplateAbfalltermine],
["NkTemplateAbfalltermineReminderConfirm", LazyNkTemplateAbfalltermineReminderConfirm],
["NkTemplateAccessibility", LazyNkTemplateAccessibility],
["NkTemplateAemterDetail", LazyNkTemplateAemterDetail],
["NkTemplateAemterMitarbeiterUebersicht", LazyNkTemplateAemterMitarbeiterUebersicht],
["NkTemplateAemterUebersicht", LazyNkTemplateAemterUebersicht],
["NkTemplateAktuelles", LazyNkTemplateAktuelles],
["NkTemplateAmt", LazyNkTemplateAmt],
["NkTemplateArchivUebersicht", LazyNkTemplateArchivUebersicht],
["NkTemplateArtikelDetail", LazyNkTemplateArtikelDetail],
["NkTemplateArtikelUebersicht", LazyNkTemplateArtikelUebersicht],
["NkTemplateAusschreibungen", LazyNkTemplateAusschreibungen],
["NkTemplateAusstattung", LazyNkTemplateAusstattung],
["NkTemplateBaugebieteDetail", LazyNkTemplateBaugebieteDetail],
["NkTemplateBaugebieteFlurstuecke", LazyNkTemplateBaugebieteFlurstuecke],
["NkTemplateBaugebieteKarte", LazyNkTemplateBaugebieteKarte],
["NkTemplateBaugebieteUebersicht", LazyNkTemplateBaugebieteUebersicht],
["NkTemplateBildergalerie", LazyNkTemplateBildergalerie],
["NkTemplateBildergalerieWebcontact", LazyNkTemplateBildergalerieWebcontact],
["NkTemplateBrancheneintraege", LazyNkTemplateBrancheneintraege],
["NkTemplateBrancheneintraegeDetail", LazyNkTemplateBrancheneintraegeDetail],
["NkTemplateBrancheneintraegeRubrik", LazyNkTemplateBrancheneintraegeRubrik],
["NkTemplateBrancheneintraegeRubriken", LazyNkTemplateBrancheneintraegeRubriken],
["NkTemplateBrancheneintrag", LazyNkTemplateBrancheneintrag],
["NkTemplateDokumente", LazyNkTemplateDokumente],
["NkTemplateFilterBrancheneintraege", LazyNkTemplateFilterBrancheneintraege],
["NkTemplateFilterRatsinfosystem", LazyNkTemplateFilterRatsinfosystem],
["NkTemplateFilterVeranstaltungen", LazyNkTemplateFilterVeranstaltungen],
["NkTemplateFormularAbfalltermineReminder", LazyNkTemplateFormularAbfalltermineReminder],
["NkTemplateFormularBrancheneintrag", LazyNkTemplateFormularBrancheneintrag],
["NkTemplateFormularCorona", LazyNkTemplateFormularCorona],
["NkTemplateFormularFuehrungenAnfrage", LazyNkTemplateFormularFuehrungenAnfrage],
["NkTemplateFormularKontakt", LazyNkTemplateFormularKontakt],
["NkTemplateFormularPauschalenAnfrage", LazyNkTemplateFormularPauschalenAnfrage],
["NkTemplateFormularPinnwand", LazyNkTemplateFormularPinnwand],
["NkTemplateFormularSchadensmeldung", LazyNkTemplateFormularSchadensmeldung],
["NkTemplateFormularVeranstaltung", LazyNkTemplateFormularVeranstaltung],
["NkTemplateFormularVerein", LazyNkTemplateFormularVerein],
["NkTemplateGoogleAlbums", LazyNkTemplateGoogleAlbums],
["NkTemplateHeader", LazyNkTemplateHeader],
["NkTemplateIFrame", LazyNkTemplateIFrame],
["NkTemplateIntranetArtikelUebersicht", LazyNkTemplateIntranetArtikelUebersicht],
["NkTemplateIntranetConfig", LazyNkTemplateIntranetConfig],
["NkTemplateIntranetLogin", LazyNkTemplateIntranetLogin],
["NkTemplateIntranetLogout", LazyNkTemplateIntranetLogout],
["NkTemplateIntranetPasswortChange", LazyNkTemplateIntranetPasswortChange],
["NkTemplateIntranetPasswortNew", LazyNkTemplateIntranetPasswortNew],
["NkTemplateIntranetPasswortReset", LazyNkTemplateIntranetPasswortReset],
["NkTemplateKontakt", LazyNkTemplateKontakt],
["NkTemplateLinks", LazyNkTemplateLinks],
["NkTemplateMitarbeiter", LazyNkTemplateMitarbeiter],
["NkTemplateMitarbeiterDetail", LazyNkTemplateMitarbeiterDetail],
["NkTemplateMitarbeiterUebersicht", LazyNkTemplateMitarbeiterUebersicht],
["NkTemplateOeffnungszeiten", LazyNkTemplateOeffnungszeiten],
["NkTemplateOrt", LazyNkTemplateOrt],
["NkTemplatePagination", LazyNkTemplatePagination],
["NkTemplatePinnwandDetail", LazyNkTemplatePinnwandDetail],
["NkTemplatePinnwandPortal", LazyNkTemplatePinnwandPortal],
["NkTemplatePinnwandSperren", LazyNkTemplatePinnwandSperren],
["NkTemplatePinnwandUebersicht", LazyNkTemplatePinnwandUebersicht],
["NkTemplatePortal", LazyNkTemplatePortal],
["NkTemplatePreise", LazyNkTemplatePreise],
["NkTemplatePwaUebersicht", LazyNkTemplatePwaUebersicht],
["NkTemplateRaeteTaetigkeitsbereicheUebersicht", LazyNkTemplateRaeteTaetigkeitsbereicheUebersicht],
["NkTemplateRaeteUebersicht", LazyNkTemplateRaeteUebersicht],
["NkTemplateRatsinfosystemBericht", LazyNkTemplateRatsinfosystemBericht],
["NkTemplateRatsinfosystemBerichteUebersicht", LazyNkTemplateRatsinfosystemBerichteUebersicht],
["NkTemplateRatsinfosystemDetail", LazyNkTemplateRatsinfosystemDetail],
["NkTemplateRatsinfosystemLogin", LazyNkTemplateRatsinfosystemLogin],
["NkTemplateRatsinfosystemLogout", LazyNkTemplateRatsinfosystemLogout],
["NkTemplateRatsinfosystemPasswortAendern", LazyNkTemplateRatsinfosystemPasswortAendern],
["NkTemplateRatsinfosystemTermin", LazyNkTemplateRatsinfosystemTermin],
["NkTemplateRatsinfosystemTermineUebersicht", LazyNkTemplateRatsinfosystemTermineUebersicht],
["NkTemplateRatsinfosystemUebersicht", LazyNkTemplateRatsinfosystemUebersicht],
["NkTemplateServiceBwAbc", LazyNkTemplateServiceBwAbc],
["NkTemplateServiceBwFormulare", LazyNkTemplateServiceBwFormulare],
["NkTemplateServiceBwKontaktpersonen", LazyNkTemplateServiceBwKontaktpersonen],
["NkTemplateServiceBwKontaktpersonenDetails", LazyNkTemplateServiceBwKontaktpersonenDetails],
["NkTemplateServiceBwLebenslagen", LazyNkTemplateServiceBwLebenslagen],
["NkTemplateServiceBwLebenslagenDetails", LazyNkTemplateServiceBwLebenslagenDetails],
["NkTemplateServiceBwLeistungen", LazyNkTemplateServiceBwLeistungen],
["NkTemplateServiceBwLeistungsDetails", LazyNkTemplateServiceBwLeistungsDetails],
["NkTemplateServiceBwOrganisationseinheit", LazyNkTemplateServiceBwOrganisationseinheit],
["NkTemplateServiceBwOrganisationseinheiten", LazyNkTemplateServiceBwOrganisationseinheiten],
["NkTemplateServiceBwOrganisationseinheitenMinimal", LazyNkTemplateServiceBwOrganisationseinheitenMinimal],
["NkTemplateServiceBwOrganisationseinheitsDetails", LazyNkTemplateServiceBwOrganisationseinheitsDetails],
["NkTemplateSpacing", LazyNkTemplateSpacing],
["NkTemplateSuche", LazyNkTemplateSuche],
["NkTemplateVeranstaltungen", LazyNkTemplateVeranstaltungen],
["NkTemplateVeranstaltungenDetail", LazyNkTemplateVeranstaltungenDetail],
["NkTemplateVeranstaltungenUebersicht", LazyNkTemplateVeranstaltungenUebersicht],
["NkTemplateVideothekWebcontact", LazyNkTemplateVideothekWebcontact],
["NkTemplateWegweiserAbc", LazyNkTemplateWegweiserAbc],
["NkTemplateWegweiserFormulare", LazyNkTemplateWegweiserFormulare],
["NkTemplateWegweiserLebenslageVerfahren", LazyNkTemplateWegweiserLebenslageVerfahren],
["NkTemplateWegweiserLebenslagen", LazyNkTemplateWegweiserLebenslagen],
["NkTemplateWegweiserUebersicht", LazyNkTemplateWegweiserUebersicht],
["NkTemplateWegweiserVerfahren", LazyNkTemplateWegweiserVerfahren],
["NkTemplateWegweiserVerfahrenDetail", LazyNkTemplateWegweiserVerfahrenDetail],
["NkTemplateWegweiserVerfahrenVorgaenge", LazyNkTemplateWegweiserVerfahrenVorgaenge],
["NkTemplateWidgetNetzeBW", LazyNkTemplateWidgetNetzeBW],
["NkTemplateZeitstrahl", LazyNkTemplateZeitstrahl],
["NkAnnouncement", LazyNkAnnouncement],
["NkWidgetPushNotification", LazyNkWidgetPushNotification],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
